// Cart Recommendation Popup Trigger and Swiper Initialization
(function() {
  // Store swiper instances globally to handle re-renders
  window.cartRecommendationSwipers = window.cartRecommendationSwipers || {};

  function initPopupSwiper(popup, productId) {
    const swiperEl = popup.querySelector('.cart-recommendation-popup__swiper');
    if (!swiperEl) {
      console.error('Swiper element not found for product:', productId);
      return;
    }

    // Destroy existing instance if it exists to allow re-initialization
    if (window.cartRecommendationSwipers[productId]) {
      try {
        window.cartRecommendationSwipers[productId].destroy(true, true);
      } catch (e) {
        console.log('Error destroying swiper:', e);
      }
      delete window.cartRecommendationSwipers[productId];
    }

    // Check if Swiper is available
    if (typeof Swiper === 'undefined') {
      console.error('Swiper library not loaded');
      return;
    }

    const variantCount = parseInt(popup.dataset.variantCount) || 0;
    const isMobile = window.innerWidth <= 1024; // Mobile and tablet (up to 1024px)
    const variantsContainer = popup.querySelector('.cart-recommendation-popup__variants');

    // Remove flex class if previously added (for re-initialization)
    if (variantsContainer) {
      variantsContainer.classList.remove('cart-recommendation-popup__variants--flex');
    }

    // Desktop with 5 or less variants - show as flex row, no slider
    if (!isMobile && variantCount <= 5) {
      if (variantsContainer) {
        variantsContainer.classList.add('cart-recommendation-popup__variants--flex');
      }
      console.log('Using flex mode for', variantCount, 'variants (desktop)');
      return;
    }

    // Mobile with less than 4 variants - show as flex row, no slider
    if (isMobile && variantCount < 4) {
      if (variantsContainer) {
        variantsContainer.classList.add('cart-recommendation-popup__variants--flex');
      }
      console.log('Using flex mode for', variantCount, 'variants (mobile)');
      return;
    }

    // Initialize Swiper with observer to handle visibility changes
    // Only reaches here for: mobile with 4+ variants OR desktop with 6+ variants
    console.log('Initializing Swiper for product:', productId, 'variants:', variantCount);

    // Only enable loop and pagination when there are more slides than visible
    // Mobile slider for 4 or more variants, not for 2 or 3
    const needsSlider = isMobile ? variantCount >= 4 : variantCount > 5;

    window.cartRecommendationSwipers[productId] = new Swiper(swiperEl, {
      slidesPerView: 3,
      spaceBetween: 8,
      loop: isMobile && variantCount >= 4, // Enable loop on mobile when 4 or more variants
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      pagination: {
        el: popup.querySelector('.cart-recommendation-popup__pagination'),
        clickable: true,
        dynamicBullets: variantCount > 5 // Use dynamic bullets for many slides
      },
      breakpoints: {
        0: {
          slidesPerView: 3,
          spaceBetween: 8
        },
        1025: {
          slidesPerView: 5,
          spaceBetween: 16
        }
      },
      on: {
        init: function() {
          console.log('Swiper initialized successfully for product:', productId);
        }
      }
    });

    // Hide pagination when not needed (slides fit in view)
    // Show pagination on mobile when 4 or more variants
    const paginationEl = popup.querySelector('.cart-recommendation-popup__pagination');
    if (paginationEl) {
      if (!isMobile || variantCount < 4) {
        paginationEl.style.display = 'none';
      } else {
        paginationEl.style.display = 'flex';
      }
    }
  }

  // Use event delegation on document for dynamically added buttons
  document.addEventListener('click', function(e) {
    const button = e.target.closest('.upgrade-cart-popup-trigger');
    if (!button) return;

    const productId = button.dataset.productId;
    const popup = document.querySelector('.cart-recommendation-popup[data-product-id="' + productId + '"]');

    if (popup) {
      popup.classList.add('active');
      document.body.style.overflow = 'hidden';

      // Initialize Swiper immediately after popup is shown
      initPopupSwiper(popup, productId);
    }
  });
})();
